// BulletPoints.js
import React from "react";

function BulletPointsView({ data }) {
  if (!data || typeof data !== "object") return null;

  const entries = Object.entries(data);

  return (
    <div className="bullet-points-nlp">
      {/* {data["User name"] ? (
        <p>
          Here is the information about <strong>{data["User name"] || "User"}</strong>
          :
        </p>
      ) : (
        <p>Here is the information:</p>
      )} */}
      <ul>
        {entries.map(([key, value]) => (
          <li key={key}>
            <strong>{key.replace(/_/g, " ")}:</strong> {String(value)}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BulletPointsView;
